import NotificationsApiService from "../api/NotificationsApiService";
import { IXSifterNotificationListRequest, IXSifterUserNotificationList } from "../types/XSifterAppUser";
import UserAuthService from "./UserAuthService";

export default class NotificationsService {
    private userAuthService = UserAuthService.getInstance();
    private notificationsApi = new NotificationsApiService();

    public async getUnreadNotificationsCount() : Promise<number> {
        return this.notificationsApi.getUnreadNotificationsCount(this.userAuthService.getToken() ?? "");
    }

    public async getNotifications(request: IXSifterNotificationListRequest) : Promise<IXSifterUserNotificationList> {
        return this.notificationsApi.getNotifications(this.userAuthService.getToken() ?? "", request);
    }

    public async markNotificationRead(id: string): Promise<boolean> {
        return this.notificationsApi.markNotificationRead(this.userAuthService.getToken() ?? "", id);
    }
    
    public async markNotificationArchived(id: string): Promise<boolean> {
        return this.notificationsApi.markNotificationArchived(this.userAuthService.getToken() ?? "", id);
    }

    public async deleteNotification(id: string): Promise<boolean> {
        return this.notificationsApi.deleteNotification(this.userAuthService.getToken() ?? "", id);
    }

}